
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { TableDownstreamDashboardsQueryVariables, TableDownstreamDashboardsQuery, DashboardsDisplayGridRowDataFragment, TableDownstreamDashboardsFilteredByColumnQueryVariables, TableDownstreamDashboardsFilteredByColumnQuery, DashboardSortOrder , TableDownstreamDashboardsFilteredByColumnDocument , TableDownstreamDashboardsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { DashboardsDisplayGrid, DashboardsDisplayGridRowData, getRowDataForDashboard } from '../sharedDisplayGrid/DashboardsDisplayGrid';
import { DashboardsValidSortFields } from '../sorting/sortProviders/DashboardsGridSortProvider';

type QueryVariables = TableDownstreamDashboardsQueryVariables;
type QueryResults = TableDownstreamDashboardsQuery;
type QueryResultListNode = DashboardsDisplayGridRowDataFragment;
type GridRowData = DashboardsDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamDashboardsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamDashboardsFilteredByColumnQuery;
type QueryResultListNodeWithFilter = DashboardsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamDashboardsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  return resultData && resultData.columns && resultData.columns[0] &&
    resultData.columns[0].downstreamDashboardsConnection;
}

export type TableDownstreamDashboardsQueryGridProps =
  GridSortProps<DashboardsValidSortFields> & {
    readonly tableId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function TableDownstreamDashboardsQueryGrid(props: TableDownstreamDashboardsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDashboardsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDashboardsLineageGridMessage();

  return props.filteredColumnId ? (
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
      queryGql={TableDownstreamDashboardsFilteredByColumnDocument}
      partialQueryVariables={{ columnId: props.filteredColumnId, orderBy: props.orderBy as DashboardSortOrder }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForDashboard}
    >
      {({ rowStore }) => <DashboardsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TableDownstreamDashboardsDocument}
      partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as DashboardSortOrder }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForDashboard}
    >
      {({ rowStore }) => <DashboardsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
